import React from 'react'
import '../../Styles/AdditionalPages/Vision.css'

export default function Vision() {
  return (
    <div className='vision'>
        Work under process
    </div>
  )
}
